import {generateUUID} from '@functions/helpers/genarateUUID.js';

export const DEFAULT_SUGGESTION_FAQs = [
  {
    questionId: generateUUID(),
    question: '🛒 Track my order',
    answer: `<p>You can track your order using the tracking number provided in your shipping confirmation email. Click on <a href="#chatty-tracking">Track</a> navigation&nbsp;</p>`
  },
  {
    questionId: generateUUID(),
    question: '🚚 How long does delivery take?',
    answer: `<p>Typically, it takes 3-5 business days to receive your order. We're doing our best to deliver it promptly for you.</p>`
  },
  {
    questionId: generateUUID(),
    question: '🔁 Return policy',
    answer: `<p>Please check our return/refund/exchange policy <a href="https://{{shopifyDomain}}/policies/refund-policy" target="_blank">here</a>.</p>`
  }
];
